import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none" {...props}>
    <path
      fill="#000"
      d="m18.38 10.165-2.99 2.99a5.529 5.529 0 0 1-7.818 0 1.185 1.185 0 1 1 1.668-1.668 3.179 3.179 0 0 0 4.472 0l2.99-2.99a3.162 3.162 0 1 0-4.471-4.472l-.948.957a1.187 1.187 0 0 1-1.678-1.678l.958-.958a5.528 5.528 0 1 1 7.818 7.819Zm-9.663 6.307-.948.958a3.162 3.162 0 1 1-4.472-4.472l2.991-2.99a3.179 3.179 0 0 1 4.472 0 1.185 1.185 0 0 0 1.668-1.67 5.519 5.519 0 0 0-7.818 0L1.62 11.29a5.528 5.528 0 0 0 7.817 7.818l.958-.957a1.187 1.187 0 0 0-1.678-1.679Z"
    />
  </svg>
);
export default SvgLinkBlack;
